import { useEffect, useRef } from 'react'
import TagManager from 'react-gtm-module'

function useGTM() {
  const isInitialized = useRef(false)

  useEffect(() => {
    if (isInitialized.current) return

    TagManager.initialize({ gtmId: 'GTM-N8LQSVFS' })
    isInitialized.current = true
  }, [])
}

export default useGTM
